<template>
  <div class="localHighlightTempDetail" v-if="monthlyAverage">
    <div class="f7">The graph below shows the monthly average of high and low temperatures in {{ cityName }} throughout the year.</div>
    <mvtChart v-if="getChartData" :data="getChartData"></mvtChart>
    <div class="grid xs-grid-cols-1 sm-grid-cols-2">
        <div class="inline bg-danger flex middle left corner">
            <i class="icon-natural-light"></i>
            <div class="f7">{{monthlyAverage.warmestText}}</div>
        </div>
        <div class="inline bg-brand flex middle left corner">
            <i class="icon-staycation"></i>
            <div class="f7">{{monthlyAverage.coolestText}}</div>
        </div>
    </div>
    <span class="see-less" v-if='!hideToggle'>
        <a class="link f7" @click="toggleMonthlyAvg()">Show Less  Monthly Average <i class="f7 icon-angle-up"></i></a>
    </span>
  </div>
  <div class="text-center markettrends-schoolcard-noresult" v-else><i class="icon-search f1"></i> No Results</div>
</template>

<script src="./mvt-localhighlighttempdetail.js"></script>

<style lang="scss">
    @use "./mvt-localhighlighttempdetail.scss" as *;
</style>